export default "__VITE_ASSET__2xOkIZ4g__"